import { TextField, DefaultButton, PrimaryButton, ProgressIndicator } from "@fluentui/react";
import { Authentication } from "../../common/views/Authentication";
import {
    textFieldStyles, defaultButtonStyles, primaryButtonStyles, styles
} from "../../common/views/DefaultStyles";
import { RouteUtils } from "../../common/views/RouteUtils";
import { Utils } from "../../common/views/Utils";
import { AccountModel, SignupModel } from "../models/AccountTypes";
import { useConfirmAccountVM } from "../viewmodels/ConfirmAccountVM";
import { accountCallback } from "../viewmodels/LoginVM";
import { ConfirmAccountView } from "./ConfirmAccountView";
import PhoneView from "./PhoneView";

type SignupProps = {
    form: SignupModel;
    errorMessages: any;
    loading: boolean;
    onValueChange: (field: keyof SignupModel, value: any) => void;
    submit: (callback: accountCallback) => void;
    showConfirm: boolean;
    setShowConfirm: (value: boolean) => void;
}

function LoginView({
    form, errorMessages, onValueChange, submit, loading, showConfirm, setShowConfirm
}: SignupProps) {
    //const isMobile = Utils.isMobile();
    const isMobile = window.innerWidth <= 500;
    const id = "login-form-wrapper" + (isMobile ? "-mobile" : "");
    const width6 = Utils.getColumnWidth(6);
    const width12 = Utils.getColumnWidth(12);

    const confirmVM = useConfirmAccountVM(false);

    const onSubmit = () => {
        Authentication.setCountryCode(form.countryCode);
        Authentication.setPhoneNo(form.phoneNo);
        Authentication.setEmail(form.email ?? "");

        submit(onSubmitResult);
    }

    const onSubmitResult = (account: AccountModel) => {
        if (!account.isConfirmed) {
            const isByEmail = !Utils.isNullOrEmpty(form.email);
            confirmVM.sendCode(account, isByEmail);
            setShowConfirm(true);
        } else {
            RouteUtils.goHome();
        }
    }

    const onPasswordKeyDown = (event: any) => {
        if (event.keyCode === 13) {
            onSubmit();
        }
    }

    const phoneView = () => {
        return <>
            <PhoneView
                showTelegram={false}
                form={form}
                errorMessages={errorMessages}
                onValueChange={onValueChange}
                isRequired={true} />
        </>;
    }

    const emailInput = () => {
        return <div className="ms-Grid-row pt-10 left">
            <div className={width12}>
                <TextField
                    label="Email"
                    defaultValue={form.email}
                    required
                    type="Email"
                    errorMessage={errorMessages.email}
                    onChange={(_, v) => onValueChange("email", v || "")}
                    styles={textFieldStyles}
                />
            </div>
        </div>;
    }

    const passwordInput = () => {
        return <div className="ms-Grid-row pt-10 left">
            <div className={width12}>
                <TextField
                    label="Password"
                    defaultValue={form.password}
                    required
                    type="Password"
                    errorMessage={errorMessages.password}
                    onChange={(_, v) => onValueChange("password", v || "")}
                    onKeyDown={onPasswordKeyDown}
                    styles={textFieldStyles}
                />
            </div>
        </div>;
    }

    const firstNameInput = () => {
        return <div className={width6 + " left"}>
            <TextField
                label="First Name"
                defaultValue={form.firstName}
                required
                errorMessage={errorMessages.firstName}
                onChange={(_, v) => onValueChange("firstName", v || "")}
                styles={textFieldStyles}
            />
        </div>;
    }

    const lastNameInput = () => {
        return <div className={width6 + " left"}>
            <TextField
                label="Last Name"
                defaultValue={form.lastName}
                required
                errorMessage={errorMessages.lastName}
                onChange={(_, v) => onValueChange("lastName", v || "")}
                styles={textFieldStyles}
            />
        </div>;
    }

    const buttons = () => {
        return <div className="ms-Grid-row pt-20">
            <div className={width6}>
                <DefaultButton onClick={RouteUtils.goHome} styles={defaultButtonStyles}>
                    Cancel
                </DefaultButton>
            </div>
            <div className={width6}>
                <PrimaryButton onClick={onSubmit} styles={primaryButtonStyles}>
                    Signup
                </PrimaryButton>
            </div>
        </div>;
    }

    const mainContent = () => {
        return <div id={id} className="pv-10 ph-15" style={styles.middle}>
            <div className="login-form box">
                <div className="ms-Grid ph-0">
                    <div className={"left font-title p-15"} style={{ paddingTop: 6 }}>
                        Signup New Account
                    </div>

                    <hr style={{ backgroundColor: "lightgray", height: 1, border: "none" }} />

                    <div className="pt-10 pb-20 ph-15">
                        {phoneView()}
                        {emailInput()}
                        {passwordInput()}

                        <div className="ms-Grid-row pt-10">
                            {firstNameInput()}
                            {lastNameInput()}
                        </div>

                        {!loading && buttons()}
                        {loading && <div className="pt-10">
                            <ProgressIndicator label="Submitting" description="" />
                        </div>}
                    </div>
                </div>
            </div>
        </div>;
    }

    return <>
        {showConfirm && <>
            <ConfirmAccountView
                form={confirmVM.form}
                errorMessages={confirmVM.errorMessages}
                loading={confirmVM.loading}
                counter={confirmVM.counter}
                onValueChange={confirmVM.setField}
                lastByEmail={confirmVM.lastByEmail}
                resendCode={confirmVM.resendCode}
                confirm={confirmVM.confirm}
                showResetPassword={confirmVM.showResetPassword}
            />
        </>}

        {!showConfirm && mainContent()}
    </>
}

export default LoginView;